(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
var modal = document.querySelector(".modal");
var trigger = document.querySelector(".trigger");
var closeButton = document.querySelector(".close-button");

function toggleModal() {
    modal.classList.toggle("show-modal");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

trigger.addEventListener("click", toggleModal);
closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["month-picks"] && !window.DesignMode) return;
  try {
    
jQuery('#slider_content_month').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  infinite: false,
  speed: 0,
  asNavFor: '.slider-thumb',
  arrows: false
});
jQuery('#slider_thumb_month').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.sliderContent',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
		infinite: true,
        dots: false 
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
		infinite: true,
        dots: false
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();
})();
